import { Reveal } from "@/components/landing/Reveal";

export function FounderSection() {
  return (
    <section className="bg-amtm-bg pt-8 pb-24 md:pb-32" data-testid="landing-founder-section">
      <div className="max-w-6xl mx-auto px-6 md:px-10 grid md:grid-cols-2 gap-10 md:gap-16 items-center">
        <Reveal className="-mt-10 relative z-10">
          <img
            src="/images/ganesh.jpg"
            alt="Ganesh Nayak, Founder of Animal Matter To Me, feeding street dogs"
            loading="lazy"
            className="w-full rounded-2xl shadow-2xl object-cover"
          />
        </Reveal>

        <Reveal delay={0.1}>
          <p className="text-xs md:text-sm font-semibold uppercase tracking-[0.18em] text-amtm-teal mb-5">
            Why we exist
          </p>
          <blockquote className="font-display text-2xl md:text-4xl text-amtm-text leading-snug mb-5">
            &ldquo;Animals deserve dignity and care, just like humans.&rdquo;
          </blockquote>
          <p className="text-sm font-semibold text-amtm-textMuted mb-6">— Ganesh Nayak, Founder, Animal Matter To Me</p>
          <p className="text-base text-amtm-textMuted leading-relaxed">
            Ganesh began rescuing animals as a schoolboy, inspired by his mother Jaya Nayak, who devoted her life to
            saving every species. In 2010 he founded AMTM to scale her mission. Today AMTM runs a full veterinary
            hospital in Malad and a cage-free sanctuary in Kolad — and has never turned an animal away.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
